import React from 'react';
import FormError from '../FormError';

class CompleteAchPurchaseButton extends React.Component {
  state = {
    error: null,
    success: false,
  };

  completeWithAch = () => {
    const { completeWithAch, purchaseId } = this.props;
    this.setState({ error: null, success: false });
    completeWithAch(purchaseId)
      .then((response) => this.setState({ success: true }))
      .catch((error) =>
        this.setState({ error: error.errors ? error.errors : error }),
      );
  };

  render() {
    const { error, success } = this.state;
    return (
      <React.Fragment>
        <button
          onClick={this.completeWithAch}
          className="btn btn-primary mar-t mar-r"
        >
          Complete with ACH
        </button>
        {success && (
          <div className="text-success mar-t">Successfully completed</div>
        )}
        {error ? (
          <div className="mar-t">
            <FormError error={error} />
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export default CompleteAchPurchaseButton;
